import { lazy, LazyExoticComponent, ComponentType } from 'react';
const PreLiquidationClient = lazy(() => import('pages/orders/TaxesClient/PreLiquidationClient'));
const SignatureControl = lazy(() => import('pages/configuration/Signature'));
const CustomsDestinationConfig = lazy(() => import('pages/configuration/CustomsDestinationConfig'));
const OrderFlowContainer = lazy(() => import('pages/orders/FlowContainer'));
const OrderListPublic = lazy(() => import('pages/orders/main/OrderListClient'));
const OrderList = lazy(() => import('pages/orders/main/OrderContainer'));
const Operative = lazy(() => import('pages/dashboards/Operative'));

export interface IRoute {
    path: string;
    pathLabel: string | ((state?: unknown) => string);
    key?: string;
    component: LazyExoticComponent<ComponentType<unknown>>;
}

export const routes: IRoute[] = [
    {
        path: '/',
        key: 'operative',
        pathLabel: 'Operativo',
        component: Operative,
    },
    {
        path: 'custom/operative',
        key: 'operative',
        pathLabel: 'Operativo',
        component: Operative,
    },
    {
        path: 'custom/orders',
        key: 'OrderList',
        pathLabel: 'OrderList',
        component: OrderList,
    },
    {
        path: 'customs/orders/:clientId',
        key: 'OrderList',
        pathLabel: 'OrderList',
        component: OrderListPublic,
    },
    {
        path: 'custom/orders/:orderId',
        key: 'OrderFlowContainer',
        pathLabel: 'OrderFlowContainer',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/summary',
        key: 'OrderSummary',
        pathLabel: 'Summary',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/documents',
        key: 'OrderDocuments',
        pathLabel: 'Documents',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/items',
        key: 'OrderItems',
        pathLabel: 'Items',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/taxes',
        key: 'OrderTaxes',
        pathLabel: 'Taxes',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/customs',
        key: 'OrderCustoms',
        pathLabel: 'Customs',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/deposit',
        key: 'OrderDeposit',
        pathLabel: 'Deposit',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/orders/:orderId/control',
        key: 'OrderControl',
        pathLabel: 'Control',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/signature',
        key: 'SignatureControl',
        pathLabel: 'SignatureControl',
        component: SignatureControl,
    },
    {
        path: 'custom/customs_destination_config',
        key: 'CustomsDestinationConfig',
        pathLabel: 'Configuración de destino aduanero',
        component: CustomsDestinationConfig,
    },

    {
        path: 'custom/orders/:orderId/pre-liquidation',
        key: 'OrderPreLiquidation',
        pathLabel: 'PreLiquidation',
        component: PreLiquidationClient,
    },
    {
        path: 'pre-liquidation/approve/:orderId/:guidLiquidation/:guidReceiptNotification',
        key: 'PreLiquidationApproveParams',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/pre-liquidation/approve/:orderId/:guidLiquidation/:guidReceiptNotification',
        key: 'CustomPreLiquidationApproveParams',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'customs/pre-liquidation/approve/:orderId/:guidLiquidation/:guidReceiptNotification',
        key: 'CustomsPreLiquidationApproveParams',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'pre-liquidation/approve',
        key: 'PreLiquidationApprove',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'custom/pre-liquidation/approve',
        key: 'CustomPreLiquidationApprove',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'customs/pre-liquidation/approve',
        key: 'CustomsPreLiquidationApprove',
        pathLabel: 'Aprobación Pre-Liquidación',
        component: OrderFlowContainer,
    },
    {
        path: 'customs/inspection/photos/:guidCustomsOperationInspection/:guidOperationContainer',
        key: 'OrderCustoms',
        pathLabel: 'Customs',
        component: OrderFlowContainer,
    },
    {
        path: 'customs/inspection/photos/:guidCustomsOperationInspection',
        key: 'OrderCustoms',
        pathLabel: 'Customs',
        component: OrderFlowContainer,
    },
    {
        path: 'customs/control/photos/:guidCustomsOperationInspection',
        key: 'OrderCustoms',
        pathLabel: 'Customs',
        component: OrderFlowContainer,
    },
];